import React from 'react';
import { TextField } from '@material-ui/core';

import { CurrencyTextField, SelectWithOptions } from '../../components';
import { claimNotificationReasons } from '../../support/constants';

export default function ClaimNotificationMovement({ movement, onChange }) {
  return (
    <>
      <SelectWithOptions
        name="reason"
        label="Reason"
        value={movement.reason}
        onChange={onChange}
        options={claimNotificationReasons}
        required={true}
      />
      <CurrencyTextField
        name="value"
        label="Value"
        onChange={onChange}
        helperText="Must be greater than 0"
        required={true}
        allowNegative={false}
        allowZero={false}
      />
      <TextField
        name="comment"
        label="Comment"
        onChange={onChange}
        variant="outlined"
        required={true}
        multiline={true}
        rows={3}
      />
    </>
  );
}
